import styled from 'styled-components';
import { mixin, color } from 'shared/utils/styles';

export const TextButton = styled.span`
  ${mixin.clickable}
  color: ${color.blue}
`;

export default TextButton;
